<script>
  import { hexToRgbA } from "./helpers.js";

  export let fg;
  export let paused;
  export let universalMode;
  $: bg = universalMode ? '#ffffff' : fg ;

</script>

<div class="round-btn" style="background-color:{hexToRgbA(bg, 0.65)}">
  {#if paused}
    <!-- content here -->

    <svg 
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3" /></svg
    >
  {:else}
    <svg 
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="paused"
      ><rect x="6" y="4" width="4" height="16" /><rect
        x="14"
        y="4"
        width="4"
        height="16"
      /></svg
    >
  {/if}
</div>

<style>
  .round-btn {
    width: 2.25em;
    height: 2.25em;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5em;
  }

  svg {
    width: 1.25em;
    height: 1.25em;
    margin-left: 0.25em;
  }

  svg.paused{
    margin-left: 0;
  }
</style>
